import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const LinkStyled = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(203,61,66,.59);
  margin: 20px 0px;
  text-decoration: none;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
    max-width: 25px;
    margin-right: 6px;
  }

  p {
    color: #000;
    font-size: 12px;
    margin: 0;
  }
`;

const ButtonBack = ({
  title = 'Identificação',
  step = '1',
  totalSteps = '2',
  onClick,
  ...rest
}) => {
  const history = useHistory();

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
      return;
    }

    if (rest.href) {
      return;
    }

    event.preventDefault();
    history.goBack();
  };

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <LinkStyled {...rest} onClick={handleClick}>
      <div className="login__back-container">
        <img className="login__back-img" src="https://zonasul.vtexassets.com/arquivos/voltar-background-vermelho.svg" alt="Botão voltar" />
      </div>
      <div className="login__back-container">
        <p className="login__back-text">{title} {step}/{totalSteps}</p>
      </div>
    </LinkStyled>
  )
}

export default ButtonBack;
